// The reports this page offers. `name` is what the dropdown, the table
// and the CSV file name show, so it is also the value stored on each report.
export const REPORT_TYPES = {
  unitDayWise: "Unit Consumed - Day Wise",
  temperature: "Temperature",
  equipmentLogs: "Equipment Logs",
  hourlyUnits: "Hourly Units Data",
  storeAnalytics: "Store Analytics",
};

// The reports the dropdown offers. Temperature, Equipment Logs and Hourly
// Units Data are hidden for now; their code is kept, so adding one back here
// is all it takes.
export const OFFERED_REPORT_TYPES = [REPORT_TYPES.unitDayWise, REPORT_TYPES.storeAnalytics];

export const REPORT_TYPE_OPTIONS = OFFERED_REPORT_TYPES.map((name) => ({
  value: name,
  label: name,
}));

// Reports that run on a picked set of devices rather than every device in the
// selected properties.
export const NEEDS_EQUIPMENT = [
  REPORT_TYPES.equipmentLogs,
  REPORT_TYPES.hourlyUnits,
  REPORT_TYPES.unitDayWise,
];

// Reports whose equipment picker also takes device IDs typed in by hand, for
// meters that are not in any selected property.
export const ALLOWS_MANUAL_DEVICES = [REPORT_TYPES.unitDayWise];

// The Site shown for a device typed in by hand.
export const NO_PROPERTY_SITE = "Not in a property";

// Reports read per store rather than per device, so a store with no devices
// loaded can still be reported on.
export const STORE_LEVEL = [REPORT_TYPES.storeAnalytics];

// The longest range, in days and inclusive of both ends, each report type may
// be run over. Types not listed have no limit.
export const MAX_RANGE_DAYS = {
  [REPORT_TYPES.storeAnalytics]: 15,
};

// How many stores the Store Analytics report fetches at once. Each call is a
// heavy query on the JFL API, so this stays well short of all at once.
export const STORE_ANALYTICS_CONCURRENCY = 6;

// /analysis/hourly/multiple takes this many devices per call.
export const HOURLY_BATCH_SIZE = 5;

// Synced unit readings above this are bad data and are dropped from the
// day-wise total.
export const MAX_SYNCED_UNIT = 10;

export const SELECT_ALL = "select_all";

export const DATE_FORMAT = "DD-MM-YYYY";
export const TIME_FORMAT = "h:mm:ss A";
